import styled from 'styled-components';

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background-color: #eee;
  border-radius: 3px;
  margin: 0.5rem 0;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: ${props => (props.current / props.max) * 100}%;
    background-color: ${props => {
      const ratio = props.current / props.max;
      if (ratio > 0.9) return props.theme.colors.error;
      if (ratio > 0.7) return props.theme.colors.warning;
      return props.theme.colors.success;
    }};
    transition: width 0.3s ease;
  }
`;

export const ProgressText = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  color: ${props => props.theme.colors.textSecondary};
`;

const ProgressComponents = {
  ProgressBar,
  ProgressText
};

export default ProgressComponents;
